import './bootstrap';
import '../css/app.css';

import { createApp } from 'vue'; // Import Vue 3's createApp function
import SignPdf from './Components/SignPdf.vue'
import PdfEditor from './Components/PdfEditor.vue';
import AppWrapper from './Components/AppWrapper.vue';

const app = createApp({
    components: {
        PdfEditor,
        SignPdf,
        AppWrapper
    },

});
app.mount('#app');